import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../api/client";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const nextTo = new URLSearchParams(loc.search).get("next") || "/";
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back!");
            nav(nextTo);
        } catch (e) {
            setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-12 animate-fade-slide">
            <div className="w-full max-w-md bg-white border border-brand-line rounded-3xl p-8 md:p-10">
                <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange mb-2">Welcome back</div>
                <h1 className="font-heading font-black text-4xl tracking-tighter mb-6">Sign in</h1>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="text-xs font-bold text-brand-moss mb-2 uppercase tracking-wider block">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="login-email"
                            className="w-full bg-brand-cream border-none rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-orange"
                        />
                    </div>
                    <div>
                        <label className="text-xs font-bold text-brand-moss mb-2 uppercase tracking-wider block">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="login-password"
                            className="w-full bg-brand-cream border-none rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-orange"
                        />
                    </div>
                    {error && <p data-testid="login-error" className="text-sm text-destructive font-bold">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="login-submit"
                        className="w-full bg-brand-orange text-white font-bold py-4 rounded-xl btn-lift disabled:opacity-50"
                    >
                        {loading ? "Signing in..." : "Sign in"}
                    </button>
                </form>
                <p className="text-sm text-center mt-6 text-brand-moss">
                    New to Globic India?{" "}
                    <Link to="/signup" className="font-bold text-brand-orange hover:underline">
                        Create an account
                    </Link>
                </p>
            </div>
        </div>
    );
}
